import { ROLES_CONVERT } from "../common/roles";
import { convertRolesName } from "../common/utils";
import { useTranslation } from "react-i18next";

const PEER_NAME_PLACEHOLDER = "peerName";
const PEER_ROLE_PLACEHOLDER = "peerRole";

export const getVideoTileLabel = ({ peerName, peerRole, isLocal, track }) => {
  const isPeerPresent = peerName !== undefined;
  const { t } = useTranslation();

  const labelMap = new Map([
    [[true, "screen"].toString(), t("lbl_my_screen")],
    [
      [true, "regular"].toString(),
      t("fm_you_content", {
        content: `${PEER_NAME_PLACEHOLDER} - ${PEER_ROLE_PLACEHOLDER}`,
      }),
    ],
    [
      [false, "screen"].toString(),
      `${PEER_NAME_PLACEHOLDER} - ${PEER_ROLE_PLACEHOLDER}`,
    ],
    [
      [false, "regular"].toString(),
      `${PEER_NAME_PLACEHOLDER} - ${PEER_ROLE_PLACEHOLDER}`,
    ],
    [
      [true, undefined].toString(),
      t("fm_you_content", {
        content: `${PEER_NAME_PLACEHOLDER} - ${PEER_ROLE_PLACEHOLDER}`,
      }),
    ],
    [
      [false, undefined].toString(),
      `${PEER_NAME_PLACEHOLDER} - ${PEER_ROLE_PLACEHOLDER}`,
    ],
  ]);

  if (!isPeerPresent || !track) {
    // for peers with only audio track
    return isPeerPresent
      ? labelMap
          .get([isLocal, undefined].toString())
          .replace(PEER_NAME_PLACEHOLDER, peerName)
          .replace(
            PEER_ROLE_PLACEHOLDER,
            t("obj_roles." + ROLES_CONVERT[convertRolesName(peerRole)])
          )
      : "";
  }
  const isLocallyMuted = track.volume === 0;
  // Map [isLocal, videoSource] to the label to be displayed.
  let label = labelMap.get([isLocal, track.source].toString());
  if (label) {
    label = label
      .replace(PEER_NAME_PLACEHOLDER, peerName)
      .replace(
        PEER_ROLE_PLACEHOLDER,
        t("obj_roles." + ROLES_CONVERT[convertRolesName(peerRole)])
      );
  } else {
    label = `${peerName} - ${t(
      "obj_roles." + ROLES_CONVERT[convertRolesName(peerRole)]
    )} ${track.source}`;
  }
  label = `${label}${track.degraded ? `(${t("lbl_signal")})` : ""}`;
  return `${label}${isLocallyMuted ? ` (${t("lbl_mute_mic")})` : ""}`;
};
